module.exports = __webpack_public_path__ + "./docs/img/big-icon-function.6a4363e73483f7076ab962a28c17b4b9.svg";